import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { FlowOfFunds, WireTransferCategory } from '../../../../models/FlowOfFunds/flow-of-funds.model';

export interface RemoveReceiptEvidenceArg {
    engagementId: number;
    category: WireTransferCategory;
    sourceRowId: number | null;
}

export const RemoveReceiptEvidence = createAsyncThunk(
    'flowOfFunds/removeReceiptEvidence',
    async (arg: RemoveReceiptEvidenceArg, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.delete(
                `/api/FlowOfFunds/${arg.engagementId}/WireTransfers/Evidence/Receipt`,
                {
                    data: {
                        category: arg.category,
                        sourceRowId: arg.sourceRowId,
                    },
                }
            );

            if (response.status !== 200) {
                throw new Error('Failed to remove the receipt evidence document');
            }

            return response.data as FlowOfFunds;
        } catch (error) {
            createNotification(
                'There was an error while removing the evidence document.',
                'error'
            );
            throw error;
        }
    }
);
